<template>
  <div class="hook-numbers u-w10of12 u-pad-x-1of12 u-row u-evenly u-wrap u-pad-y-xl u-pad-y-md--sm u-pad-x-md">
    <div v-for="data in data.numbers" :key="data.percent" class="u-center u-full-width--sm u-marg-y-sm--sm">
      <p class="t-h5 u-black">
        <span class="u-blue">{{ data.indicatif }}</span> {{ data.percent }}
      </p>
      <p class="t-text--big u-marg-t-md u-marg-t-sm--sm">{{ data.title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HookNumbers',
  props: {
    data: {
      type: Object,
      required: true
    },
  }
}
</script>

<style lang="stylus">

</style>